import { createContext } from 'react';

const InnerWidthWindowContext = createContext(window.innerWidth);

export default InnerWidthWindowContext;
